import { createBrowserRouter, Navigate } from 'react-router';
import { AccessPage } from '@/pages/access/access-page';
import { DashboardPage } from '@/pages/dashboard/dashboard-page';
import { DataPage } from '@/pages/data/data-page';
import { DATA_TABS } from '@/pages/data/data-tabs';
import { DocumentsPage } from '@/pages/documents/documents-page';
import { InventoryPage } from '@/pages/inventory/inventory-page';
import { LoginPage } from '@/pages/login/login-page';
import { NotesPage } from '@/pages/notes/notes-page';
import { ShoppingPage } from '@/pages/shopping/shopping-page';
import { TasksPage } from '@/pages/tasks/tasks-page';
import { msg } from '@/shared/i18n/msg';
import { AppLayout } from '../layouts/app-layout';
import { RequireSession } from './require-session';
import type { RouteHandle } from './route-handle';

function crumb(label: string): RouteHandle {
  return { crumb: label };
}

const dataTab: RouteHandle = {
  crumb: (params) => DATA_TABS.find((tab) => tab.value === params.tab)?.label,
};

export const router = createBrowserRouter([
  { path: '/sign-in', element: <LoginPage /> },
  {
    element: <RequireSession />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { index: true, element: <DashboardPage />, handle: crumb(msg('Dashboard')) },
          { path: 'inventory', element: <InventoryPage />, handle: crumb(msg('Inventory')) },
          { path: 'shopping', element: <ShoppingPage />, handle: crumb(msg('Shopping')) },
          { path: 'tasks', element: <TasksPage />, handle: crumb(msg('Tasks')) },
          { path: 'documents', element: <DocumentsPage />, handle: crumb(msg('Documents')) },
          { path: 'notes', element: <NotesPage />, handle: crumb(msg('Notes')) },
          {
            path: 'data',
            handle: crumb(msg('Data')),
            children: [
              { index: true, element: <Navigate to="/data/sync" replace /> },
              { path: ':tab', element: <DataPage />, handle: dataTab },
            ],
          },
          { path: 'access', element: <AccessPage />, handle: crumb(msg('Sessions and access')) },
          // Old addresses (bookmarks, installed shortcuts).
          { path: 'settings', element: <Navigate to="/data/sync" replace /> },
          { path: 'trash', element: <Navigate to="/data/trash" replace /> },
          { path: 'more', element: <Navigate to="/" replace /> },
          { path: '*', element: <Navigate to="/" replace /> },
        ],
      },
    ],
  },
]);
